import Input from "../../../../components/FormComponents/Input";

const AwsSesConfig = ({ data, onChange }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className={"d_flex flex_column gap_3"}>
      <Input
        name="aws_ses_access_key"
        value={data.aws_ses_access_key}
        onChange={handleInputChange}
        placeholder="Enter AWS SES Access Key"
        label="AWS Access Key"
      />
      <Input
        name="aws_ses_secret_key"
        value={data.aws_ses_secret_key}
        onChange={handleInputChange}
        placeholder="Enter AWS SES Secret Key"
        label="AWS Secret Key"
        type="password"
      />
      <Input
        name="aws_ses_region"
        value={data.aws_ses_region}
        onChange={handleInputChange}
        placeholder="Enter AWS Region (e.g., us-east-1)"
        label="AWS Region"
      />
    </div>
  );
};
export default AwsSesConfig;
